import React, { useMemo } from 'react';
import AssetLinksTable from '@components/Tables/AssetLinksTable/AssetLinksTable';
import { useTypedSelector } from '@hooks';
import { InfiniteScroll } from '@components/InfiniteScroll/InfiniteScroll';
import LottieComponent from '@components/Lottie';
import { useListAssetReviewsQuery } from '@hooks/queries/assetReview';
import { Skeleton } from 'antd';

function CampaignSharedLinksTab() {
  const campaignInfoModal = useTypedSelector(
    ({ modal }) => modal.campaignInfoModal
  );

  const {
    data: assetReviewsData,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useListAssetReviewsQuery({
    params: {
      campaignId: campaignInfoModal?.campaign?.id || ''
    },
    enabled: !!campaignInfoModal?.visible
  });

  const assetReviews = useMemo(() => {
    return assetReviewsData?.pages.flatMap((page) => page.edges);
  }, [assetReviewsData]);

  return (
    <>
      <p className="tab_description">
        Manage links that were shared externally.
      </p>
      <div className="links_container">
        {isLoading || !!assetReviews?.length ? (
          <InfiniteScroll
            loading={isFetchingNextPage ? 'more' : false}
            next={fetchNextPage}
            hasMore={hasNextPage ?? false}
            loader={<Skeleton.Input active style={{ height: 84 }} />}
          >
            <AssetLinksTable
              linksData={assetReviews || []}
              loading={isLoading}
            />
          </InfiniteScroll>
        ) : (
          <div className="empty_links">
            <LottieComponent className="icon" view="addShareLink" />
            <div className="copy">Start sharing media with your team.</div>
          </div>
        )}
      </div>
    </>
  );
}

export default CampaignSharedLinksTab;
